import { pageTitle } from "../PageTitle";

import HeaderOne from "../Header/HeaderOne";
import videoSource from "../../assets/videos/Automating_Accounts_Payable.mp4";
import videoSource1 from "../../assets/videos/AI-invoice.mp4";
import FooterOne from "../Footer/FooterOne";
import AiInvoiceBanner from "./../../assets/images/banner/invoice-banner.png";

const AiInvoice = () => {
  pageTitle("Invoice Data Capture");

  return (
    <>
      <HeaderOne></HeaderOne>

      <div className="ai-overlay-wrapper">
        <img src={AiInvoiceBanner} alt="AI Operations" className="main" />

        <div className="ai-overlay">
          {/* Centered text */}
          <div className="ai-overlay-center-project-text">
            <h2 className="ai-overlay-project">
              AI-Powered Invoice Data Capture
            </h2>
            <p>Cut invoice processing time. Reduce errors. Stay audit-ready.</p>
          </div>
        </div>
      </div>

      <section class="siw-rpa-section">
        <div class="siw-rpa-container-data-engineering container">
          <div class="siw-rpa-content">
            {/* <span class="siw-rpa-tag">
              Still Manually Searching item codes & rates in SOR (Schedule of
              Rates) documents?
            </span> */}

            <div class="siw-rpa-text">
              <p>
                The Smart iLab Works <span className="SiW">(SiW)</span>{" "}
                AI-Powered Invoice Data Capture is specifically designed to cut
                invoice processing time, reduce manual errors, and ensure your
                business remains audit-ready. It transforms the traditional,
                manual AP process into a streamlined, four-stage automated
                workflow.
              </p>
            </div>

            <div className="siw-rpa-desc">
              <h3>Key Capabilities</h3>
              <p className="pt-2">
                The AI application goes beyond basic invoice processing by
                streamlining vendor onboarding, multi-channel capture,
                AIextraction, and direct ERP/accounting integration:
              </p>
              <p
                className="pt-2"
                style={{ fontWeight: "bold", color: "#009999" }}
              >
                The Four-Step Workflow{" "}
              </p>
              <ol className="pt-2 pb-0">
                <li>
                  Automated Vendor Management: Collects vendor documents,
                  validates details, and creates/updates vendor records in
                  ERP/accounting.
                </li>

                <li>
                  Multi-Channel Invoice Capture: Bots capture invoices from
                  email/shared inboxes and digitize paper invoices using OCR +
                  AI.
                </li>

                <li>
                  AI Extraction & Classification: Classifies invoice type and
                  extracts key fields like vendor, invoice no., date, totals,
                  tax, and line items.
                </li>

                <li>
                  Seamless Accounting Integration: Automatically posts extracted
                  data into ERP/accounting workflows for real-time updates and
                  faster processing.
                </li>
              </ol>
            </div>
          </div>

          <div class="siw-rpa-cta">
            <h4 style={{ color: "rgb(230, 233, 55)" }}>Free Trial Available</h4>
            <p>
              <span style={{ fontSize: "20px", fontWeight: "bold" }}>SiW</span>{" "}
              is currently offering a free trial session. <br />
              Our team will create a dedicated AI-powered app.
            </p>
            <p className="siw-project-website-text-top">
              To explore more about the{" "}
              <strong>AI-powered Invoice Data Capture</strong>, Click 👉{" "}
              <a
                href="https://idc.siw.sg/"
                target="_blank"
                rel="noopener noreferrer"
                className="siw-project-website-link blinking1"
              >
                Invoice Data Capture
              </a>
              .
            </p>
            <a href="/contact" class="siw-rpa-btn">
              <i className="bi bi-calendar-week btn-icon"></i>
              Start a Free Trial
            </a>
          </div>
        </div>
      </section>
      <div className="container" style={{ marginTop: "-10px !important" }}>
        <div class="siw-rpa-desc mt-0">
          <h3>Business Benefits</h3>
          <p className="pt-2">
            Implementing this automation provides several key advantages:
          </p>
          <ul className="pt-1">
            <li>
              Faster Processing: Drastically reduces the time from invoice
              receipt to payment.
            </li>

            <li>
              Error Reduction: Minimizes the risks associated with manual data
              entry
            </li>
            <li>
              Error Reduction: Minimizes the risks associated with manual data
              entry
            </li>
            <li>
              Compliance: Ensures stronger compliance and keeps your records
              organized for audits
            </li>
          </ul>
        </div>
      </div>
      <section className="siw-project-section">
        <div className="siw-project-container container">
          <div className="row g-4 align-items-start">
            <div className="col-md-6 mt-3">
              <h3 className="siw-project-heading">
                Introducing Invoice Data Capture
              </h3>

              <div className="siw-project-video-wrapper">
                <video className="siw-project-video" controls>
                  <source src={videoSource} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>

            <div className="col-md-6 mt-3">
              <h3 className="siw-project-heading">Watch a Demo Video</h3>

              <div className="siw-project-video-wrapper">
                <video className="siw-project-video" controls>
                  <source src={videoSource1} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
          <p className="siw-project-website-text">
            To explore more about the{" "}
            <strong>AI-powered Invoice Data Capture</strong>, Click 👉{" "}
            <a
              href="https://idc.siw.sg/"
              target="_blank"
              rel="noopener noreferrer"
              className="siw-project-website-link blinking"
            >
              Invoice Data Capture
            </a>
            .
          </p>
        </div>
      </section>
      <FooterOne></FooterOne>
    </>
  );
};
export default AiInvoice;
